/**
 * @file Openapi Schema
 * @version 0.1.0
 * @author Openapi Generator src_common/server/node_task/run_app/openapi/openapi.ts
 * @date 2025-12-04T14:04:57.038Z
 *
 * Details:
 * --- File generated by generator do not modify this file manually ---
 */

import { z } from 'zod';


// #/components/schemas/yaspaBankingApiApprovePayoutRequest
export const YaspaBankingApiApprovePayoutRequestZod = z.object({
    transactionId: z.number(),
    citizenTransactionId: z.string(),
});
export type YaspaBankingApiApprovePayoutRequestType = z.TypeOf<typeof YaspaBankingApiApprovePayoutRequestZod>;


// #/components/schemas/yaspaBankingApiResolvedPayoutResponse
export const YaspaBankingApiResolvedPayoutResponseZod = z.object({
    citizenTransactionId: z.string(),
    merchantId: z.string(),
    merchantTradingName: z.string(),
    customerIdentifier: z.string(),
    journeyType: z.string(),
    version: z.string(),
    authType: z.string(),
    transactionStatus: z.string(),
    isPayloadEncrypted: z.boolean(),
    creationDate: z.number(),
    citizenCounterPartyId: z.string(),
    providerPaymentId: z.string().optional(),
    currency: z.string(),
    paymentGiro: z.string(),
    merchantBankCode: z.string(),
    merchantAccountNumber: z.string(),
    merchantBank: z.string(),
    counterPartyBank: z.string(),
    counterPartyBankCode: z.string(),
    counterPartyAccountNumber: z.string(),
    counterPartyAccountName: z.string(),
    reference: z.string(),
    amount: z.number(),
    rejectionReason: z.string().optional(),
});
export type YaspaBankingApiResolvedPayoutResponseType = z.TypeOf<typeof YaspaBankingApiResolvedPayoutResponseZod>;


// #/components/schemas/yaspaBankingApiSuccessResolvedPayoutResponse
export const YaspaBankingApiSuccessResolvedPayoutResponseZod = z.object({
    data: YaspaBankingApiResolvedPayoutResponseZod,
});
export type YaspaBankingApiSuccessResolvedPayoutResponseType = z.TypeOf<typeof YaspaBankingApiSuccessResolvedPayoutResponseZod>;


// #/components/schemas/yaspaBankingApiBadRequestError
export const YaspaBankingApiBadRequestErrorZod = z.object({
    code: z.string(),
    message: z.string(),
});
export type YaspaBankingApiBadRequestErrorType = z.TypeOf<typeof YaspaBankingApiBadRequestErrorZod>;


// #/components/schemas/yaspaBankingApiErrorBadRequestError
export const YaspaBankingApiErrorBadRequestErrorZod = z.object({
    errors: z.array(YaspaBankingApiBadRequestErrorZod).optional(),
});
export type YaspaBankingApiErrorBadRequestErrorType = z.TypeOf<typeof YaspaBankingApiErrorBadRequestErrorZod>;


// #/components/schemas/yaspaBankingApiUnauthorized
export const YaspaBankingApiUnauthorizedZod = z.object({
    code: z.string(),
    message: z.string(),
});
export type YaspaBankingApiUnauthorizedType = z.TypeOf<typeof YaspaBankingApiUnauthorizedZod>;


// #/components/schemas/yaspaBankingApiErrorUnauthorized
export const YaspaBankingApiErrorUnauthorizedZod = z.object({
    errors: z.array(YaspaBankingApiUnauthorizedZod).optional(),
});
export type YaspaBankingApiErrorUnauthorizedType = z.TypeOf<typeof YaspaBankingApiErrorUnauthorizedZod>;


// #/components/schemas/yaspaBankingApiInternalServerError
export const YaspaBankingApiInternalServerErrorZod = z.object({
    code: z.string(),
    message: z.string(),
});
export type YaspaBankingApiInternalServerErrorType = z.TypeOf<typeof YaspaBankingApiInternalServerErrorZod>;


// #/components/schemas/yaspaBankingApiErrorInternalServerError
export const YaspaBankingApiErrorInternalServerErrorZod = z.object({
    errors: z.array(YaspaBankingApiInternalServerErrorZod).optional(),
});
export type YaspaBankingApiErrorInternalServerErrorType = z.TypeOf<typeof YaspaBankingApiErrorInternalServerErrorZod>;


// #/components/schemas/yaspaBankingApiRejectPayoutRequest
export const YaspaBankingApiRejectPayoutRequestZod = z.object({
    transactionId: z.number(),
    citizenTransactionId: z.string(),
    rejectionReason: z.union([z.literal('Cancelled by Staff'), z.literal('Rejected by Staff')]),
});
export type YaspaBankingApiRejectPayoutRequestType = z.TypeOf<typeof YaspaBankingApiRejectPayoutRequestZod>;


// #/components/schemas/yaspaBankingApiAccountReference
export const YaspaBankingApiAccountReferenceZod = z.object({
    id: z.number(),
    name: z.string(),
    type: z.string(),
});
export type YaspaBankingApiAccountReferenceType = z.TypeOf<typeof YaspaBankingApiAccountReferenceZod>;


// #/components/schemas/yaspaBankingApiUpdateWithdrawalRequest
export const YaspaBankingApiUpdateWithdrawalRequestZod = z.object({
    status: z.string(),
    citizenTransactionId: z.string(),
    assignee: YaspaBankingApiAccountReferenceZod.optional(),
});
export type YaspaBankingApiUpdateWithdrawalRequestType = z.TypeOf<typeof YaspaBankingApiUpdateWithdrawalRequestZod>;


// #/components/schemas/yaspaBankingApiWithdrawalResponse
export const YaspaBankingApiWithdrawalResponseZod = z.object({
    id: z.string(),
    paymentType: z.string().optional(),
    currencyCode: z.string(),
    status: z.string().optional(),
    amount: z.number().optional(),
});
export type YaspaBankingApiWithdrawalResponseType = z.TypeOf<typeof YaspaBankingApiWithdrawalResponseZod>;


// #/components/schemas/yaspaBankingApiSuccessWithdrawalResponse
export const YaspaBankingApiSuccessWithdrawalResponseZod = z.object({
    data: YaspaBankingApiWithdrawalResponseZod,
});
export type YaspaBankingApiSuccessWithdrawalResponseType = z.TypeOf<typeof YaspaBankingApiSuccessWithdrawalResponseZod>;


// #/components/schemas/yaspaBankingApiPayOutRequest
export const YaspaBankingApiPayOutRequestZod = z.object({
    customerIdentifier: z.string(),
    amount: z.string(),
    currency: z.string(),
    paymentGiro: z.string(),
    reference: z.string(),
    description: z.string(),
    supportedCountries: z.array(z.string()).optional(),
    language: z.string().optional(),
    successRedirectUrl: z.string().optional(),
    failureRedirectUrl: z.string().optional(),
    successBankRedirectUrl: z.string().optional(),
    failureBankRedirectUrl: z.string().optional(),
    assignee: YaspaBankingApiAccountReferenceZod.optional(),
    channel: z.string().optional(),
});
export type YaspaBankingApiPayOutRequestType = z.TypeOf<typeof YaspaBankingApiPayOutRequestZod>;


// #/components/schemas/yaspaBankingApiYaspaLinkResponse
export const YaspaBankingApiYaspaLinkResponseZod = z.object({
    link: z.string(),
    transactionId: z.number().optional(),
});
export type YaspaBankingApiYaspaLinkResponseType = z.TypeOf<typeof YaspaBankingApiYaspaLinkResponseZod>;


// #/components/schemas/yaspaBankingApiSuccessYaspaLinkResponse
export const YaspaBankingApiSuccessYaspaLinkResponseZod = z.object({
    data: YaspaBankingApiYaspaLinkResponseZod,
});
export type YaspaBankingApiSuccessYaspaLinkResponseType = z.TypeOf<typeof YaspaBankingApiSuccessYaspaLinkResponseZod>;

